import React, { Component } from 'react'
import { singleData } from './config'
import Styles from '../../Css/View360/View360.module.css'

export default class ToggleButton extends Component {
  render() {
    return (
        <div className={[Styles[this?.props?.mobileView ? 'exterior-interior-toggle-mobile-view' : 'exterior-interior-toggle']]}>
        <ul className={[Styles[this?.props?.mobileView ? 'exterior-interior-tabs-mobile-view' : 'exterior-interior-tabs']]}>
            {singleData?.iframeTabs?.map((elements, indx) => {
                return (
                    <li key={`iframeTabs-${indx}`} onClick={()=>this.props.updateState(elements?.key)} className={[Styles['tabs'],elements?.key === this.props.value.showExtOrInt ? Styles["active"] : Styles[""]].join(' ')} >{elements?.title}</li>
                )
            })}
            <div className={[Styles[this?.props?.mobileView ? 'ext-tabs-bg-mobile-view' :'ext-tabs-bg']]}></div>
        </ul>
    </div>
    )
  }
}
